import { httpGet, httpPost, httpDelete } from "@/request/http";

let path = "/pays";

export default {
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  save(item) {
    return httpPost(path, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  before(payId) {
    return httpPost(`${path}/sequences/before`, {
      payId,
    });
  },
  after(payId) {
    return httpPost(`${path}/sequences/after`, {
      payId,
    });
  },
  getCreditCardPayList(payId) {
    return httpGet(`${path}/${payId}/creditcardpaylist`);
  },
  saveCreditCardPayList(payId, items) {
    return httpPost(`${path}/${payId}/creditcardpaylist`, items);
  },
  getPays(id) {
    return httpGet(`/modules/${id}/pays`);
  },
  addPays(items) {
    return httpPost(`/modules/pays/addbatch`, items);
  },
  removePays(items) {
    return httpPost(`/modules/pays/deletebatch`, items);
  },
};
